import React, { Component, Fragment } from "react";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getShiftTypes, deleteShiftType } from "../actions/shiftTypeActions";

import { Button } from "@material-ui/core";

import DataListWithSearchFilter from "./DataListWithSearchFilter";
import formatPrice from "../utils/format-price";

class ShiftTypeList extends Component {
  state = {
    shiftTypes: [],
  };

  componentDidMount() {
    this.refreshData();
  }

  deleteShiftType(shiftTypeId) {
    this.props.deleteShiftType(shiftTypeId).then(() => {
      this.setState({
        shiftTypes: this.state.shiftTypes.filter((g) => g.id != shiftTypeId),
      });
    });
  }

  refreshData = () => {
    this.setState({ shiftTypes: [] });

    this.props.getShiftTypes().then((shiftTypes) => {
      this.setState({ shiftTypes });
    });
  };

  render() {
    return (
      <Fragment>
        <Button variant="contained" color="primary" onClick={this.refreshData}>
          Zoek
        </Button>

        <DataListWithSearchFilter
          data={this.state.shiftTypes.map((shiftType) => {
            return {
              id: shiftType.id,
              title: shiftType.name,
              subtitle: formatPrice(shiftType.price),
              ctxMenu: [
                {
                  label: "Wijzigen",
                  action: () =>
                    (window.location.href = `/shifttype/${shiftType.id}/update`),
                },
                {
                  label: "Verwijderen",
                  action: () => this.deleteShiftType(shiftType.id),
                  confirm: true,
                },
              ],
            };
          })}
          isFetching={this.props.isFetching}
          successMessage={this.props.successMessage}
          errorMessage={this.props.errorMessage}
        />
      </Fragment>
    );
  }
}

ShiftTypeList.propTypes = {
  getShiftTypes: PropTypes.func.isRequired,
  deleteShiftType: PropTypes.func.isRequired,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.any,
  isFetching: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  successMessage: state.shifttype.deleteShiftType.successMessage,
  errorMessage: state.shifttype.deleteShiftType.errorMessage,
  isFetching:
    state.shifttype.getShiftTypes.isFetching ||
    state.shifttype.deleteShiftType.isFetching,
});

export default connect(mapStateToProps, { getShiftTypes, deleteShiftType })(
  ShiftTypeList,
);



// WEBPACK FOOTER //
// ./src/components/ShiftTypeList.js